exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bgc-light-blue[data-v-73602050]{background-color:#f1f8ff}.bgc-white[data-v-73602050]{background-color:#fff}.hide-scrollbar[data-v-73602050]::-webkit-scrollbar{display:none}.survey-divider[data-v-73602050]{margin-bottom:3.5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73602050","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserCard.vue
// module id = 835
// module chunks = 0